import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@lanl-web/lanl-components';
import { useOutsideClick } from '../../utils/useOutsideClick';
import { LocalNavDesktop } from './LocalNavDesktop';
import { LocalNavMobile } from './LocalNavMobile';

import './LocalNav.scss';

export const LocalNav = ({ pageMap, location }) => {
  const [activeItem, setActiveItem] = useState(null);
  const menuItems = pageMap.filter(({ parent }) => parent === null);
  const ref = useRef(null);

  useOutsideClick(ref, () => {
    setActiveItem(null);
  });

  return (
    <div className='local-nav' ref={ref}>
      <div className='nav-container'>
        <LocalNavDesktop
          menuItems={menuItems}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
        />
        <Button
          className='remote-access-button'
          outline
          color='secondary'
          onClick={() =>
            window.location.replace('/library-services/remote-access')
          }
        >
          Remote Access
        </Button>
        <LocalNavMobile location={location} menuItems={menuItems} />
      </div>
    </div>
  );
};

LocalNav.defaultProps = {};

LocalNav.propTypes = {
  location: PropTypes.object,
  pageMap: PropTypes.array,
};

export default LocalNav;
